import { DatePipe } from '@angular/common';
import { Component, inject, input, OnInit, signal } from '@angular/core';
import { AdminEmptyStateComponent } from '../../../../shared/admin';
import type { FeatureRequestActivity } from '../../../../shared/models/feature-request.models';
import { FeatureRequestsService } from '../../../../shared/services/feature-requests.service';
import {
  featureRequestActivityDetail,
  featureRequestActivityTitle,
} from './feature-request-activity-labels';

@Component({
  selector: 'app-feature-request-activity-timeline',
  standalone: true,
  imports: [DatePipe, AdminEmptyStateComponent],
  templateUrl: './feature-request-activity-timeline.component.html',
  styleUrl: './feature-request-activity-timeline.component.scss',
})
export class FeatureRequestActivityTimelineComponent implements OnInit {
  private readonly service = inject(FeatureRequestsService);

  readonly requestId = input.required<string>();

  readonly items = signal<FeatureRequestActivity[]>([]);
  readonly loading = signal(false);

  readonly title = featureRequestActivityTitle;
  readonly detail = featureRequestActivityDetail;

  ngOnInit(): void {
    this.load();
  }

  reload(): void {
    this.load();
  }

  private load(): void {
    this.loading.set(true);
    this.service.listActivity(this.requestId()).subscribe({
      next: (rows) => {
        this.items.set(rows);
        this.loading.set(false);
      },
      error: () => this.loading.set(false),
    });
  }
}
